import { render, staticRenderFns } from "./QueryError.vue?vue&type=template&id=4b82f544&"
import script from "./QueryError.vue?vue&type=script&lang=js&"
export * from "./QueryError.vue?vue&type=script&lang=js&"
import style0 from "./QueryError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports